import "./sectionContextMenu.scss"
import { React, useState, useEffect, useCallback } from 'react'
import { useNavigate  } from "react-router-dom";

import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import LockOpenOutlinedIcon from '@mui/icons-material/LockOpenOutlined';

import { getProjects } from '../../services/projectService';

const SectionContextMenu = ({section, activeMenu, setActiveMenu}) => {
    const url = window.location.pathname;
    const currentSection = url.split( '/' )[1];

    const [firestoreProjects, setFirestoreProjects] = useState([]);
    const [loading, setLoading] = useState(false);
    
    const navigate = useNavigate();

    const setUnlockedStatus = (projectLink) => {
        try {
            if (!localStorage.getItem('password')) return false;
            const allowedStr = localStorage.getItem('allowed_projects');
            if (allowedStr) {
                const allowed = JSON.parse(allowedStr);
                if (allowed.includes(projectLink) || allowed.includes("/dashboard")) {
                    return true;
                }
            }
            return false;
        } catch (e) {
            return false;
        }
    };

    // Update PROJECTS data from Firestore using the centralized service
    const fetchFirestoreProjects = useCallback(async () => {
        setLoading(true);
        try {
            const projects = await getProjects();
            setFirestoreProjects(projects);
            return projects;
        } catch (e) {
            console.error("Error fetching navbar projects:", e);
        } finally {
            setLoading(false);
        }
        return [];
    }, []);

    // Pre-fetch on mount once for each context menu
    useEffect(() => {
        fetchFirestoreProjects();
    }, [fetchFirestoreProjects]);

    const openContextMenu = activeMenu === section;
    var [listOptions, setListOptions] = useState( [] )
    
    // Close menu when clicking outside
    useEffect(() => {
        if (!openContextMenu) return;
        const handleOutsideClick = () => setActiveMenu(null);
        window.addEventListener('click', handleOutsideClick);
        return () => window.removeEventListener('click', handleOutsideClick);
    }, [openContextMenu, setActiveMenu]);
    
    const getSections = async (e) => {
        let projects = firestoreProjects;
        if (projects.length === 0) {
           projects = await fetchFirestoreProjects();
        }

        if (loading && projects.length === 0) return; // Wait for initial load

        let list = []
        let hasLockedProjects = false;
        
        projects.forEach((item) => {
            const item_section = item.link.split('/').at(1).toLowerCase();
            const project_name = item.link.split('/').at(-1).toLowerCase();
            const description = item.description || `${project_name.charAt(0).toUpperCase() + project_name.slice(1)}`;
            
            if (item_section === section) {
                const unlocked = setUnlockedStatus(item.link);
                if (item.hidden && !unlocked) {
                    hasLockedProjects = true;
                    return;
                }
                list.push({
                    "name": description,
                    "link": item.link,
                    "hidden": item.hidden,
                    "unlocked": unlocked
                });
            }
        });
        
        if (hasLockedProjects && !localStorage.getItem('password')) {
            list.push({
                "name": "Private Access",
                "link": "",
                "hidden": true,
                "unlocked": false
            });
        }
 
        const isMultiProjectCategory = ["work"].includes(section);

        if (list.length === 0 || !isMultiProjectCategory) {
            navigate("/" + section);
        } else if (list.length === 1 && !isMultiProjectCategory) {
            navigate(list[0]?.link || "/");
        } else {
            setListOptions(list);
            setActiveMenu(section);
        }
    }

    const handleMouseEnter = async () => {
        const isMultiProjectCategory = ["work"].includes(section);
        if (!isMultiProjectCategory) return;

        let projects = firestoreProjects;
        if (projects.length === 0) {
            projects = await fetchFirestoreProjects();
        }

        let list = []
        let hasLockedProjects = false;
        projects.forEach((item) => {
            const item_section = item.link.split('/').at(1).toLowerCase();
            const project_name = item.link.split('/').at(-1).toLowerCase();
            const description = item.description || `${project_name.charAt(0).toUpperCase() + project_name.slice(1)}`;
            
            if (item_section === section) {
                const unlocked = setUnlockedStatus(item.link);
                if (item.hidden && !unlocked) {
                    hasLockedProjects = true;
                    return;
                }
                list.push({
                    "name": description,
                    "link": item.link,
                    "hidden": item.hidden,
                    "unlocked": unlocked
                });
            }
        });
        
        if (hasLockedProjects && !localStorage.getItem('password')) {
            list.push({ "name": "Private Access", "link": "", "hidden": true, "unlocked": false });
        }

        if (list.length > 1) {
            setListOptions(list);
            setActiveMenu(section);
        }
    }

    const handleMouseLeave = () => {
        setActiveMenu(null);
    }

 
    const openProject = (item) => {
        if (item.hidden) {
            if (item.unlocked) {
                navigate(item.link);
            } else {
                window.dispatchEvent(new CustomEvent('trigger-login', { detail: { item } }));
            }
        } else {
            navigate(item.link);
        }
    }
    
    var sectionHighlight = false
    if (section === currentSection) {
        sectionHighlight = true
    }

    return (
        <div className="sectionMenuWrapper" onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>
            <div className="sectionButtonArea">
                <div className="sectionButton" onClick={(e) => { e.stopPropagation(); getSections(e); }}>
                    <p>{section.toUpperCase()}</p>
                    <hr className={sectionHighlight? "sectionHr open" : "sectionHr"} />
                </div>
            </div>
            <div className={openContextMenu? "sectionContextMenu open" : "sectionContextMenu"} onClick={(e) => e.stopPropagation()}>
                {listOptions.map((project, index) => {
                    return(
                        <div className="projectButton" key={index} onClick={() => {openProject(project)}}>
                            <div className="projectButtonContent">
                                <div className="project">
                                    <div className={ project.hidden ? "projectLocked" : "projectLocked hidden"}>
                                        <div className={ project.unlocked ? "unLocked true" : "unLocked"}>
                                            <LockOutlinedIcon className="icon"/>
                                        </div>
                                        <div className={ project.unlocked ? "unLocked" : "unLocked true"}>
                                            <LockOpenOutlinedIcon className="icon"/>
                                        </div>
                                    </div>

                                    <label className="projectName">{project.name}</label>
                                </div>
                                <hr className={project.link === url ? "projectHR true" : "projectHR"}/>
                            </div>
                        </div>
                    )
                })}
            </div>
        </div>
    )
};

export default SectionContextMenu